import { render, staticRenderFns } from "./AssetPreview.vue?vue&type=template&id=0deb291a&scoped=true"
import script from "./AssetPreview.vue?vue&type=script&lang=js"
export * from "./AssetPreview.vue?vue&type=script&lang=js"
import style0 from "./AssetPreview.vue?vue&type=style&index=0&id=0deb291a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deb291a",
  null
  
)

export default component.exports